import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import NewOfferForm from "../../components/form/products/NewOfferForm";

export default function NewOffer() {
    const { productId } = useParams<{ productId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=ofertas`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Nova Oferta"
                description="Criar nova oferta para o produto"
            />
            <PageBreadcrumb
                pageTitle="Nova Oferta"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewOfferForm
                    productId={productId}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de ofertas
                        navigate(`/products/edit/${productId}?tab=ofertas`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar oferta:", error);
                    }}
                />
            </div>
        </>
    );
}